import { post, put, get, del } from 'aws-amplify/api';
import { processResponse } from './api_util';
import useSWR from 'swr'
import { handleApiResponse } from './api_util';


async function createOcrolusSecret(ocrolusSecretData){
    const payload={
        apiName: 'OcrolusSecretApi',
        path: `ocrolus_secret`,
        options: {
          body: {
            ocrolus_secret_data: ocrolusSecretData,
          }
        }
      }

      const restOperation = post(payload);


      const response = await restOperation.response;
      return processResponse(response)
  }

export function useCreateOcrolusSecret() {
    return async (ocrolusSecretData) => {
      try {
        const response = await createOcrolusSecret(ocrolusSecretData);
        return handleApiResponse(['OCROLUS_SECRET'],'accountName',response, 'create');
      } catch (error) {
        console.error('Error creating ocrolus secret:', error);
        throw error;
      }
    };
  }

async function getOcrolusSecrets(){
      console.log('getOcrolusSecrets')
     const payload={
      apiName: 'OcrolusSecretApi',
      path: `ocrolus_secret`

    }

    const restOperation = get(payload);


    const response = await restOperation.response;
    
    const processedResponse = processResponse(response)
    
    return processedResponse
  }

  export function useGetOcrolusSecrets(shouldFetch=true){
    const result = useSWR(
      shouldFetch ? ['OCROLUS_SECRET'] : null,
      (path) => getOcrolusSecrets(), 
    );
    return result;
  }


  async function getOcrolusSecret(accountName){

    const payload={
     apiName: 'OcrolusSecretApi',
     path: `ocrolus_secret/${accountName}`

   }

   const restOperation = get(payload);


   const response = await restOperation.response;

   return processResponse(response)
 }

 export function useGetOcrolusSecret(accountName,shouldFetch=true){
  const result = useSWR(
    shouldFetch ? ['OCROLUS_SECRET',accountName] : null,
    (path,accountName) => getOcrolusSecret(accountName), 
  );
  return result;
}




async function updateOcrolusSecret(ocrolusSecretData){
    const payload={
        apiName: 'OcrolusSecretApi',
        path: `ocrolus_secret`,
        options: {
          body: {
            ocrolus_secret_data: ocrolusSecretData,
          }
        }
      }

      const restOperation = put(payload);


      const response = await restOperation.response;
      return processResponse(response)
  }

export function useUpdateOcrolusSecret(ocrolusSecretData) {
    return async (ocrolusSecretData) => {
      try {
        const response = await updateOcrolusSecret(ocrolusSecretData);
        return handleApiResponse(['OCROLUS_SECRET'],'accountName',response, 'update');
      } catch (error) {
        console.error('Error updating ocrolus secret:', error);
        throw error;
      }
    };
  }

  async function deleteOcrolusSecret(accountName){
    const payload={
        apiName: 'OcrolusSecretApi',
        path: `ocrolus_secret/${accountName}`,
        
      }

      const restOperation = del(payload);


      const response = await restOperation.response;
      return processResponse(response)
  }

export function useDeleteOcrolusSecret(accountName) {
    return async (accountName) => {
      try {
        const response = await deleteOcrolusSecret(accountName);
        return handleApiResponse(['OCROLUS_SECRET'],'accountName',response, 'delete');
      } catch (error) {
        console.error('Error deleting ocrolus secret:', error);
        throw error;
      }
    };
  }

